import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import StartEnquiry from "./Steps/StartEnquiry";
import ParentDetail from "./Steps/ParentDetail";
import ChildDetailEnquiry from "./Steps/ChildDetail";
import Review from "./Steps/Review";
import MaximiseOptions from "./Steps/MaximiseOptions";
import Finish from "./Steps/Finish";
import styles from "./styles.module.scss";
import { getTourAvailabilities } from "./Services/EnquiryService";
import PickTimePersonTourBooking from "./Steps/PickTimePersonTourBooking";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { env } from "../../environment";
import VerifyOTP from "./Steps/VerifyOTP";
import axios, { AxiosResponse } from "axios";

declare var c4kCore: any;

const colorStep = {
    active: "bg-[#5A60EC]",
    pending: "bg-[#E3E1DD]",
    final: "bg-[#A7B7FA]",
};
interface PayloadGa4 {
    eventName: string;
    Action?: string;
    FormStep?: string;
    FeatureName?: string;
    FeatureData?: string;
    ListingType?: string;
}

export enum STEP_BY_STEP {
    START_ENQUIRY = "START_ENQUIRY",
    PARENT_DETAIL = "PARENT_DETAIL",
    CHILD_DETAIL = "CHILD_DETAIL",
    REVIEW = "REVIEW",
}

export const FORM_STEP = {
    0: "enquiry option",
    1: "parent details",
    2: "child details",
    4: "review",
    6: "register",
};

//helper to grab only the truthy ones
function pickTruthy<T extends Record<string, any>, K extends keyof T>(
    obj: T,
    keys: readonly K[]
): Partial<Pick<T, K>> {
    return keys.reduce((acc, k) => {
        const val = obj[k];
        if (val != null && val !== "") {
            acc[k] = val;
        }
        return acc;
    }, {} as Partial<Pick<T, K>>);
}

export const EnquiryV3 = (props) => {

    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const [currentStep, setCurrentStep] = useState<number>(
        // EXPERIMENT CAR-2026.4 START
        props.isSelectRequestTour ? 1 :
        // EXPERIMENT CAR-2026.4 END
        props.isSelectLiveTour
    );

    const [enquiryID, setEnquiryID] = useState<number>(0);
    const [dataEnquiry, setDataEnquiry] = useState({
        startEnquiry: [],
        parentDetail: {
            parentFirstName: props.data.parentFirstName || "",
            parentLastName: props.data.parentLastName || "",
            email: props.data.parentEmail || "",
            contactNumber: props.data.parentContactNumber || "",
            suburb: {
                label: props.data.parentSuburb,
                postcode: props.data.parentPostcode,
            },
        },
        childDetail: {},
        pickerTimePersonTour: {
            isBackDateTimeExists: false,
            startDate: "",
            endDate: "",
            tourDate: "",
            tourTime: "",
            availabilityDetailsResponse: [],
            availabilityDetails: [],
            isDateTimeApiLoading: false,
        },
        maximiseOptions: [],
        chooseTime: {},
        createAccount: {},
    });
    const [isSendGa4RegisterParent, setIsSendGa4RegisterParent] =
        useState(false);
    const isBasic =
        props.data.enquiryCentreDetailsList[0].listingType === "basic";

    const centreNames = [
        ...dataEnquiry.maximiseOptions.map((item) => item.name),
        props.initialCareCentre.name,
    ].join(", ");
    const [isPickOptionLiveTour, setIsPickOptionLiveTour] = useState(
        dataEnquiry.startEnquiry.some((item) => item.id == 4)
    );

    const arrSteps =
        // EXPERIMENT CAR-2026.4 START
        props.isSelectRequestTour
            ? [1, 2]
            :
        // EXPERIMENT CAR-2026.4 END
        props.isSelectLiveTour
            ? [1, 2, 3]
            : isPickOptionLiveTour
                ? [0, 1, 2, 3]
                : [0, 1, 2];

    const resetForm = () => {
        setIsOpen(false);
        // if (currentStep != 3 && currentStep <= 4) {
        //     sendNewEventGa4("close", FORM_STEP_GA4[currentStep].close);
        // }

        setCurrentStep(0);
        setIsPickOptionLiveTour(false);
        setDataEnquiry({
            startEnquiry: [],
            parentDetail: {
                contactNumber: props.data.isLoggedIn
                    ? props.data.parentContactNumber
                    : "",
                email: props.data.isLoggedIn ? props.data.parentEmail : "",
                parentFirstName: props.data.isLoggedIn
                    ? props.data.parentFirstName
                    : "",
                parentLastName: props.data.isLoggedIn
                    ? props.data.parentLastName
                    : "",
                suburb: {
                    label: props.data.isLoggedIn ? props.data.parentSuburb : "",
                    postcode: props.data.isLoggedIn
                        ? props.data.parentPostcode
                        : "",
                },
            },
            childDetail: {},
            maximiseOptions: [],
            pickerTimePersonTour: {
                isBackDateTimeExists: false,
                startDate: "",
                endDate: "",
                tourDate: "",
                tourTime: "",
                availabilityDetailsResponse: [],
                availabilityDetails: [],
                isDateTimeApiLoading: false,
            },
            chooseTime: {},
            createAccount: {},
        });
        document.body.classList.remove("overflow-hidden");
    };

    const handleClose = (event) => {
        if (event && event.target.classList.contains("overlay-modal")) {
            resetForm();
            return;
        }
        if (currentStep < 5) {
            c4kCore.optimizelyExitRates()
        }

        if (currentStep === 3) {
            // sendNewEventGa4("basic-upsell", "close - upsell-cta");
            if (!isPickOptionLiveTour) {
                sendNewEventGa4({
                    eventName: "enquiry_workflow",
                    FormStep: "basic upsell",
                    Action: "drop-off",
                    ListingType:
                        props.data.enquiryCentreDetailsList[0].listingType,
                });
                return goToNextStep();
            } else {
                sendNewEventGa4({
                    eventName: "enquiry_workflow",
                    FormStep: "book a tour",
                    Action: "drop-off",
                    ListingType:
                        props.data.enquiryCentreDetailsList[0].listingType,
                });
            }
        }
        if (currentStep !== 5 && currentStep !== 3) {
            sendNewEventGa4({
                eventName: "enquiry_workflow",
                FormStep: FORM_STEP[currentStep],
                Action: "drop-off",
                ListingType: props.data.enquiryCentreDetailsList[0].listingType,
            });
        }
        resetForm();
    };

    const goToNextStep = (step?: number) => {
        document.getElementById("wrap-enquiry").scrollTo(0, 0);
        setCurrentStep(step || currentStep + 1);
    };

    const goToPreviousStep = () => {
        document.getElementById("wrap-enquiry").scrollTo(0, 0);

        if (!currentStep) return;
        const isReviewStep = currentStep === 4;
        if (isReviewStep) {
            setCurrentStep(
                isPickOptionLiveTour || isBasic
                    ? currentStep - 1
                    : currentStep - 2
            );
        } else {
            if (currentStep == 1 && (props.isSelectLiveTour == 1
                // EXPERIMENT CAR-2026.4 START
                || props.isSelectRequestTour == 1
                // EXPERIMENT CAR-2026.4 END
            )) {
                handleClose(null);
            } else {
                setCurrentStep(currentStep - 1);
            }
        }
        if (currentStep === 3) {
            if (!isPickOptionLiveTour) {
                sendNewEventGa4({
                    eventName: "enquiry_workflow",
                    FormStep: "basic upsell",
                    Action: "back",
                    ListingType:
                        props.data.enquiryCentreDetailsList[0].listingType,
                });
                return;
            } else {
                sendNewEventGa4({
                    eventName: "enquiry_workflow",
                    FormStep: "book a tour",
                    Action: "back",
                    ListingType:
                        props.data.enquiryCentreDetailsList[0].listingType,
                });
            }
            // sendNewEventGa4("basic-upsell", "back - upsell-cta");
        }
        if (currentStep > 4) return;

        sendNewEventGa4({
            eventName: "enquiry_workflow",
            Action: "back",
            FormStep: FORM_STEP[currentStep],
            ListingType: props.data.enquiryCentreDetailsList[0].listingType,
        });
        // sendNewEventGa4(ACTION_GA4[currentStep], FORM_STEP_GA4[currentStep].back);
    };

    const getAllIdsFromCookies = (): string[] => {
        const cookies = document.cookie.split("; ");
        const ids: string[] = [];

        cookies.forEach((cookie) => {
            if (cookie.startsWith("brandedHash_")) {
                const id = cookie.split("=")[0].split("_")[1]; // Extract ID from cookie name
                ids.push(id);
            }
        });

        return ids;
    };

    const hasVisitedBrandedHub = getAllIdsFromCookies().includes(
        props.data.centreBrandHashId
    );

    const onNext = (payload: { data: any }) => {
        switch (currentStep) {
            case 0:
                setDataEnquiry((prev) => ({
                    ...prev,
                    startEnquiry: payload.data,
                }));
                sendNewEventGa4({
                    eventName: "enquiry_workflow",
                    Action: "finish",
                    FormStep: FORM_STEP[0],
                    ListingType:
                        props.data.enquiryCentreDetailsList[0].listingType,
                });
                payload.data.forEach((item) => {
                    sendNewEventGa4({
                        eventName: "enquiry_workflow_feature",
                        FeatureName: "enquiry type",
                        FeatureData: item.label
                            .toLowerCase()
                            .replace(/\s+/g, "-"),
                    });
                });

                goToNextStep();
                setIsPickOptionLiveTour(
                    payload.data.some((item) => item.id == 4)
                );
                break;
            case 1:
                setDataEnquiry((prev) => ({
                    ...prev,
                    parentDetail: payload.data,
                }));
                // sendNewEventGa4(ACTION_GA4[1], `parent-details`);
                goToNextStep();
                break;
            case 2:
                // sendNewEventGa4(ACTION_GA4[2], isPickOptionLiveTour ? `live-tour-booking` : `child-details`);

                if (isPickOptionLiveTour) {
                    const selectedDate = payload.data.items[0].startDate;
                    const formattedStartDate = new Date(selectedDate.startDate)
                        ?.toISOString()
                        .split("T")[0];

                    const formattedEndDate = new Date(selectedDate.endDate)
                        .toISOString()
                        .split("T")[0];

                    setDataEnquiry((prev) => {
                        prev.pickerTimePersonTour.isDateTimeApiLoading = true;
                        return prev;
                    });
                    let didRetry = false;
                    const fetchAvailabilities = () => {
                        return getTourAvailabilities(
                            formattedStartDate,
                            formattedEndDate,
                            props.data.token
                        )
                            .then((res: any) => {

                                if (res.data?.isSuccess) {
                                    setDataEnquiry((prev) => ({
                                        ...prev,
                                        childDetail: payload.data,
                                        pickerTimePersonTour: {
                                            isBackDateTimeExists: false,
                                            startDate: formattedStartDate,
                                            endDate: formattedEndDate,
                                            tourDate: "",
                                            tourTime: "",
                                            availabilityDetailsResponse:
                                                res.data.availabilityDetails,
                                            availabilityDetails: [],
                                            isDateTimeApiLoading: false,
                                            showRetryAfterInitialFailure: false,
                                        },
                                    }));
                                    goToNextStep();
                                } else {
                                    let message = res.data.errors?.[0];
                                    setDataEnquiry((prev) => ({
                                        ...prev,
                                        pickerTimePersonTour: {
                                            ...prev.pickerTimePersonTour,
                                            isDateTimeApiLoading: false,
                                        },
                                    }));

                                }
                            })
                            .catch((error) => {


                                if (!didRetry) {
                                    didRetry = true;
                                    return fetchAvailabilities();
                                }
                                setDataEnquiry((prev) => ({
                                    ...prev,
                                    childDetail: payload.data,
                                    pickerTimePersonTour: {
                                        isBackDateTimeExists: false,
                                        startDate: formattedStartDate,
                                        endDate: formattedEndDate,
                                        tourDate: "",
                                        tourTime: "",
                                        availabilityDetailsResponse: [],
                                        availabilityDetails: [],
                                        isDateTimeApiLoading: false,
                                        showRetryAfterInitialFailure: true,
                                    },
                                }));
                                goToNextStep();
                            });
                    };
                    fetchAvailabilities();
                } else {
                    setDataEnquiry((prev) => ({
                        ...prev,
                        childDetail: payload.data,
                    }));
                    goToNextStep(isBasic ? undefined : 4);
                }
                break;

            case 3:
                goToNextStep();
                break;
            case 4:
                goToNextStep();
                break;
            case 5:
                goToNextStep();
                break;
        }
    };

    const renderComponent = {
        0: (
            <StartEnquiry
                onNext={onNext}
                isLiveTourBookingAvailable={props.isOpenLiveTourBooking}
                enquiryDetail={dataEnquiry}
            />
        ),
        1: (
            <ParentDetail
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
                onNext={onNext}
                enquiryDetail={dataEnquiry}
                sendEventGa4={(payload) => sendNewEventGa4(payload)}
            />
        ),
        2: (
            <ChildDetailEnquiry
                onNext={onNext}
                enquiryDetail={dataEnquiry}
                token={props.data.token}
                isPickOptionLiveTour={isPickOptionLiveTour}
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
                sendEventGa4={(payload) => sendNewEventGa4(payload)}
            />
        ),
        3: isPickOptionLiveTour ? (
            <PickTimePersonTourBooking
                setDataEnquiry={setDataEnquiry}
                enquiryDetail={dataEnquiry}
                token={props.data.token}
                onNext={onNext}
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
                sendEventGa4={(payload) => sendNewEventGa4(payload)}
            />
        ) : (
            <MaximiseOptions
                maximiseOptions={dataEnquiry.maximiseOptions}
                sendEventGa4={(payload) => sendNewEventGa4(payload)}
                postcode={props?.initialCareCentre?.centrePostcode}
                initialCareCentre={props?.initialCareCentre}
                setDataEnquiry={setDataEnquiry}
                goToNextStep={goToNextStep}
                enquiryCentreDetailsList={
                    props.data.enquiryCentreDetailsList[0]
                }
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
            />
        ),
        4: (
            <Review
                onNext={onNext}
                setIsOpen={setIsOpen}
                enquiryDetail={dataEnquiry}
                data={props.data}
                hasVisitedBrandedHub={hasVisitedBrandedHub}
                isPickOptionLiveTour={isPickOptionLiveTour}
                sendEventGa4={(payload) => sendNewEventGa4(payload)}
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
                centreUserIdHash={
                    props.data.enquiryCentreDetailsList[0]?.centreUserIdHash
                }
                setEnquiryID={setEnquiryID}
                initialCareName={props.initialCareCentre.name}
                setSendGa4Register={() => setIsSendGa4RegisterParent(true)}
                isBasic={isBasic}
                sendNewEventGa4RoiEnquiryCurrentCentre={() =>
                    sendNewEventGa4RoiEnquiryCurrentCentre()
                }
                sendNewEventGa4RoiEnquiryUpsellCenter={(payload) =>
                    sendNewEventGa4RoiEnquiryUpsellCenter(payload)
                }
            />
        ),
        5: (
            <Finish
                centreName={centreNames}
                isLoggedIn={props.data.isLoggedIn}
                enquiryType={isPickOptionLiveTour ? "4" : "2"}
                enquiryID={enquiryID}
                enquiryDetail={dataEnquiry}
                onNext={onNext}
                onClose={handleClose}
                setIsEmailValid={setIsEmailValid}
            />
        ),
        6: (
            <VerifyOTP
                parentDetail={dataEnquiry.parentDetail}
                createAccount={dataEnquiry.createAccount}
                isEmailValid={isEmailValid}
                enquiryID={enquiryID}
                enquiryType={isPickOptionLiveTour ? "4" : "2"}
                onClose={resetForm}
                listingType={
                    props.data.enquiryCentreDetailsList[0].listingType || null
                }
                sendNewEventGa4={(payload) => sendNewEventGa4(payload)}
                sendGa4RegisterParent={() => {
                    if (isSendGa4RegisterParent) {
                        sendNewEventGa4({
                            eventName: "enquiry_workflow",
                            Action: "finish",
                            FormStep: "register",
                            ListingType:
                                props.data.enquiryCentreDetailsList[0]
                                    .listingType,
                        });
                        sendNewEventGa4({
                            eventName: "enquiry_workflow",
                            Action: "finish",
                            FormStep: "account register",
                            ListingType:
                                props.data.enquiryCentreDetailsList[0]
                                    .listingType,
                        });
                        // sendNewEventGa4("upsell-cta", "parent-register");
                    }
                }}
            />
        ),
    };

    const handleConvertContextToCentreIdAndGroupId = (context) => {
        const [centrePart, groupPart] = context.split("|");
        const centreId = centrePart.split("=")[1];
        const groupId = groupPart ? groupPart.split("=")[1] : null;
        return {
            centreId: centreId,
            centreGroupId: groupId,
        };
    };
    function buildInitialValue(payload: PayloadGa4) {
        // assemble
        const initialValue = {
            // only include these if truthy
            ...pickTruthy(payload, [
                "eventName",
                "Action",
                "FormStep",
                "ListingType",
                "FeatureName",
                "FeatureData",
            ]),
        };

        return initialValue;
    }
    const sendNewEventGa4 = (payload: PayloadGa4) => {

        c4kCore.sendGa4EventForNewEnquiry(buildInitialValue(payload));
    };
    const sendNewEventGa4RoiEnquiryCurrentCentre = () => {
        const { centreId, centreGroupId } =
            handleConvertContextToCentreIdAndGroupId(
                props.data.enquiryCentreDetailsList[0].eventContext
            ) || {};
        c4kCore.sendGa4EventForNewRoiEnquiry({
            CentreId: centreId || null,
            CentreGroupId: centreGroupId || null,
            ListingType:
                props.data.enquiryCentreDetailsList[0].listingType || null,
            Suburb: props.data.enquiryCentreDetailsList[0].centreSuburb,
            Postcode: props.data.enquiryCentreDetailsList[0].centrePostcode,
            State: props.data.enquiryCentreDetailsList[0].centreState,
        });
    };
    const sendNewEventGa4RoiEnquiryUpsellCenter = (payload: {
        centreUserIdHash: string;
        centreGroupId: string;
        listingType: string;
        suburb: string;
        postcode: string;
        state: string;
    }) => {
        c4kCore.sendGa4EventForNewRoiEnquiry({
            CentreId: payload.centreUserIdHash || null,
            CentreGroupId: payload.centreGroupId || null,
            ListingType: payload.listingType || null,
            Suburb: payload.suburb || null,
            Postcode: payload.postcode || null,
            State: payload.state || null,
        });
    };
    useEffect(() => {
        sendNewEventGa4({
            eventName: "enquiry_workflow",
            Action: "start",
            FormStep: FORM_STEP[0],
            ListingType: props.data.enquiryCentreDetailsList[0].listingType,
        });
    }, []);

    useEffect(() => {
        if (props.isOpen) {
            setIsOpen(true);
            // EXPERIMENT CAR-2026.4 START
            if (props.isSelectRequestTour == 1) {
                setCurrentStep(1);
                setIsPickOptionLiveTour(false);
                setDataEnquiry((prev) => {
                    return {
                        ...prev,
                        startEnquiry: [
                            {
                                label: "Request a tour",
                                subLabel:
                                    "Schedule a visit to explore the centre",
                                id: 2,
                                steps: 1,
                                icon: "fa6-solid:flag",
                            },
                        ],
                    };
                });
                return;
            }
            // EXPERIMENT CAR-2026.4 END
            setCurrentStep(props.isSelectLiveTour);
            if (props.isSelectLiveTour == 1) {
                setIsPickOptionLiveTour(true);
                setDataEnquiry((prev) => {
                    return {
                        ...prev,
                        startEnquiry: [
                            {
                                label: "Request an In-Person Tour",
                                subLabel:
                                    "Schedule a visit to explore the centre",
                                id: 4,
                                steps: 3,
                                icon: "fa6-solid:flag",
                            },
                        ],
                    };
                });
            } else {
                setIsPickOptionLiveTour(false);
            }
        }
    }, [props]);

    useEffect(() => {
        const element = document.getElementById("main-content-enquiry");
        if (element) {
            element.scrollTop = 0;
        }
    }, [currentStep]);

    return (
        <div className="font-poppins">
            <style>
                {`
                .overlay-modal {
		            background-color: rgba(0, 0, 0, 0.5) !important;
		            backdrop-filter: blur(4px) !important;
	            }
            `}
            </style>

            {isOpen && (
                <GoogleReCaptchaProvider
                    useRecaptchaNet
                    scriptProps={{ async: true, defer: true, appendTo: "body" }}
                    reCaptchaKey={env.GOOGLE_SITE_KEY_RECAPTCHAV3}
                >
                    <div
                        id="wrap-enquiry"
                        onClick={handleClose}
                        className={`enquiry-v3 fixed bg-white inset-0 overflow-y-auto`}
                        style={{ zIndex: 1006 }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className={`${`step-container-${currentStep + 1
                                }`} w-full mx-auto h-auto min-h-full bg-white flex flex-col ${props.data.isLoggedIn ? "pb-[111px]" : ""
                                }`}
                        >
                            <div className="sticky top-0 bg-white z-[11] py-5 pb-0 sm:px-4">
                                {currentStep < 5 ? (
                                    <div className="flex-shrink-0 flex justify-between px-4 sm:px-0 pb-4 md:pb-5">
                                        <button
                                            onClick={goToPreviousStep}
                                            className={`${currentStep > 0
                                                ? "visible"
                                                : "invisible"
                                                } ${`back-button-step-${currentStep + 1
                                                }`}`}
                                        >
                                            <Icon
                                                icon="ic:baseline-arrow-back-ios-new"
                                                className="text-black-1 z-5"
                                            />
                                        </button>
                                        <span className="text-[#3A3A3A] font-semibold md:font-medium">
                                            {isPickOptionLiveTour
                                                ? "Tour Booking"
                                                : "Enquiry"}
                                        </span>
                                        <button
                                            className={`${`close-button-step-${currentStep + 1
                                                }`}`}
                                            onClick={handleClose}
                                        >
                                            <Icon
                                                icon="iconamoon:close"
                                                className="z-5 text-2xl"
                                            ></Icon>
                                        </button>
                                    </div>
                                ) : (
                                    <div className="flex justify-end px-4 md:px-0">
                                        <button
                                            onClick={handleClose}
                                            className={`${`close-button-step-${currentStep + 1
                                                }`} ml-auto block pl-4 pr-0 md:pr-4 md:py-0`}
                                        >
                                            <Icon
                                                icon="streamline:delete-1-solid"
                                                width="14"
                                                height="14"
                                            />
                                        </button>
                                    </div>
                                )}
                                {(isPickOptionLiveTour && currentStep <= 3) ||
                                    (!isPickOptionLiveTour && currentStep < 3) ? (
                                    <ul className="flex-shrink-0 flex items-center md:gap-x-6 gap-x-[15px] justify-between w-full h-[10px] 4xl:px-[104px] 2xl:px-[64px] md:px-[24px] mx-auto">
                                        {arrSteps.map((step, index, array) => {
                                            const currentBg =
                                                currentStep < step
                                                    ? colorStep.pending
                                                    : currentStep === step
                                                        ? colorStep.active
                                                        : colorStep.final;
                                            const borderRadiusClass =
                                                (index === 0
                                                    ? "rounded-l-none "
                                                    : "") +
                                                (index === array.length - 1
                                                    ? " rounded-r-none"
                                                    : "") +
                                                " rounded-[5px]";
                                            return (
                                                <li
                                                    key={step}
                                                    className={`flex-[1] h-full ${currentBg} ${borderRadiusClass} relative sm:rounded-[5px]`}
                                                ></li>
                                            );
                                        })}
                                    </ul>
                                ) : (
                                    <></>
                                )}
                            </div>

                            <div
                                id="main-content-enquiry"
                                className={`flex-1 ${currentStep == 5 ? "" : "mt-6 md:mt-10"
                                    } flex md:gap-x-10 ${styles.contentEnquiry
                                    } w-full max-w-[1140px] mx-auto`}
                            >
                                {/*Profile Section*/}
                                {currentStep < 5 && currentStep !== 3 && (
                                    <div className="flex-col items-center max-w-[300px] w-full text-center w-1/3 lg:flex hidden px-6 sticky top-0">
                                        <div className="relative w-[238px] h-auto sticky top-[100px]">
                                            <div className="w-[164px] h-[167px] mb-6 mx-auto">
                                                <img
                                                    src={
                                                        props.initialCareCentre
                                                            .imageUrl
                                                    }
                                                    alt="Profile"
                                                    className="w-full h-full rounded-full object-cover border-1 border-[#D9D8DF]"
                                                />
                                            </div>

                                            {!isBasic && (
                                                <div className="inline-block px-1 py-[6px]">
                                                    <div className="flex items-center gap-1">
                                                        <Icon
                                                            icon="mdi:check-decagram"
                                                            width="24"
                                                            height="24"
                                                            style={{
                                                                color: "#5A60EC",
                                                            }}
                                                        />
                                                        <p className="font-semibold text-[12px] text-[#5A60EC]">
                                                            Verified
                                                        </p>
                                                    </div>
                                                </div>
                                            )}

                                            <h4 className="text-[16px] font-semibold text-[#3A3A3A] mb-[6px]">
                                                {props.initialCareCentre.name}
                                            </h4>
                                            <p className="text-[12px] text-[#696866]">
                                                {
                                                    props.initialCareCentre
                                                        .address
                                                }
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/*Enquiry Section*/}
                                <div className="flex-1 px-4 lg:px-0 min-w-0 relative">
                                    {renderComponent[currentStep]}
                                </div>
                            </div>
                        </div>
                    </div>
                </GoogleReCaptchaProvider>
            )}
        </div>
    );
};
